import { orderSelectorsFactory } from 'state/secondaryMarket/shared/order/order.selector';
import type { AppState } from 'state/state.model';

const select = (state: AppState, tabId: string) => {
  return state.secondaryMarket.limitOrder.order[tabId];
};
export const limitOrderTradeSelectors = orderSelectorsFactory('limitOrder', {
  getOrderLimit(state: AppState, tabId: string) {
    return select(state, tabId)?.clientLimit;
  },
  getOrderId(state: AppState, tabId: string) {
    return select(state, tabId)?.id;
  },
  getOrderExecTime(state: AppState, tabId: string) {
    return select(state, tabId)?.execTime;
  },
});
